/**
 * Quick variant selector component
 * 
 * @module component-quick-variant-selector
 * @version 1.0.0
 * @extends HTMLElement
 */
class quickVariantSelector extends HTMLElement {

    /**
     * Quick variant selector web component.
     * 
     * @constructor
     */
    constructor() {

        super();

        if (this.dataset.handle) {

            if (this.dataset.productOptions) {


                window.theme.product.loadProduct(this.dataset.handle, true).then(product => {
                    // loadProduct resolves null on a failed or throttled /products fetch
                    if (!product) return;



                    // Save options
                    this.options = this.getOptionsList(product,);


                    this.render(this.options, product);
                });

            } else {

                console.log('Missing product options', this);
            }

        } else {

            console.log('Missing product handle', this);
        }
    }

    /**
     * Update variant selector web component.
     * 
     * @param {object} product Product data.
     * @param {string} optionName Product option name.
     * @returns {undefined}
     */
    getOptionsList(product) {
        let name = "Size";

        const sizeOptionWithMultipleValues = product.options.find(option => option.name?.trim().toLowerCase() === "size" && option.values.length > 1)

        if (sizeOptionWithMultipleValues) {
            name = sizeOptionWithMultipleValues.name || "Size";
        } else {
            product.options.forEach(option => {
                if (option.values.length > 1) {
                    name = option.name;
                }
            });
        }

        if (document.querySelector(".quick-view  .swatches__swatch[data-option=" + name?.replace(/\s+/g, '-') + "]")) {
            document.querySelector(".quick-view  .swatches__swatch[data-option=" + name?.replace(/\s+/g, '-') + "]").style.display = "block";
        }

        let optionsList = [];

        const optionsWithMultipleValues = (product.options || []).filter(option => option.values && option.values.length > 1);
        const useCombined = optionsWithMultipleValues.length >= 2;

        const seenValues = new Set();

        product.variants.forEach(variant => {
            let label = "";
            if (useCombined) {
                const optionValues = [variant.option1, variant.option2, variant.option3].filter(opt => opt && opt !== 'Default Title');
                label = optionValues.join('/');
            } else {
                const mainOptionIndex = product.options_by_name[name]?.option?.position ?? -1;
                if (mainOptionIndex === 1) {
                    label = variant.option1;
                } else if (mainOptionIndex === 2) {
                    label = variant.option2;
                } else if (mainOptionIndex === 3) {
                    label = variant.option3;
                } else {
                    const optionValues = [variant.option1, variant.option2, variant.option3].filter(opt => opt && opt !== 'Default Title');
                    label = optionValues[0] || "";
                }
            }

            if (label && !seenValues.has(label)) {
                seenValues.add(label);
                optionsList.push({
                    variant: variant,
                    variantId: variant.id,
                    optionValue: label
                });
            }
        });

        console.log('optionsList is: ', name, optionsList, sizeOptionWithMultipleValues);

        return optionsList;
    }

    /**
     * Render component.
     * 
     * @param {Array} options Options array.
     * @returns {undefined}
     */
    render(options, product) {

        if (!product.variants || product.variants.length === 0) {
            this.style.display = 'none';
            return;
        }

        if (options) {

            let html = '';

            this.dataset.status = true;

            html = html + '<component-tooltip>';

            let icon = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-select" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" fill="none" stroke="none"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.0007 17.5872L23.2927 11.2933C23.4805 11.1055 23.7351 11 24.0007 11C24.2662 11 24.5209 11.1055 24.7087 11.2933C24.8965 11.481 25.002 11.7357 25.002 12.0013C25.002 12.2668 24.8965 12.5215 24.7087 12.7093L16.7087 20.7093C16.6158 20.8024 16.5054 20.8763 16.384 20.9267C16.2625 20.9771 16.1322 21.003 16.0007 21.003C15.8692 21.003 15.7389 20.9771 15.6174 20.9267C15.4959 20.8763 15.3856 20.8024 15.2927 20.7093L7.29269 12.7093C7.10492 12.5215 6.99943 12.2668 6.99943 12.0013C6.99943 11.7357 7.10492 11.481 7.29269 11.2933C7.48046 11.1055 7.73514 11 8.00069 11C8.26624 11 8.52092 11.1055 8.70869 11.2933L15.0007 17.5873C16.0007 18.5012 16.0007 18.5012 17.0007 17.5872Z" stroke="none"/></svg>';

            html = html + '<button aria-label="Open add to bag options" data-tooltip-trigger class="btn btn-link">Add to Bag' + icon + '</button>';

            html = html + '<ul data-tooltip-content>';

            console.log('options is: ', options, product);

            if (product.variants.length > 1 || product.options.length > 1) {

                let totalCharacters = 0;
                let characterLimit = 30;

                if (window.innerWidth <= 1600) {
                    characterLimit = 20;
                }

                let renderedCount = 0;
                options.forEach((option, index) => {
                    if (totalCharacters < characterLimit) {
                        const optionLength = option.optionValue.length;
                        const space = renderedCount > 0 ? 1 : 0;
                        if (totalCharacters + optionLength + space <= characterLimit) {
                            if (option.variant.available) {
                                html = html + '<li>';
                                html = html + `<button class="btn btn-link quick-variant-selector__button" data-variant-id="${option.variantId}" aria-label="Add ${option.optionValue} to bag" data-available="${option.variant.available}">${option.optionValue}</button>`;
                                html = html + '</li>';
                                totalCharacters += optionLength + space;
                                renderedCount++;
                            }
                        }
                    }
                });

                console.log('options.length is: ', options.length, renderedCount, document.querySelectorAll('[data-quick-view-handle="' + product.handle + '"]'));

                if (options.length > renderedCount) {
                    try {
                        document.querySelectorAll('[data-quick-view-handle="' + product.handle + '"]')?.forEach((moreBtn) => {
                            moreBtn.classList.remove('hidden');
                            moreBtn.textContent = '+' + (options.length - renderedCount) + ' More';
                        });
                    } catch (error) {
                        console.log('document.querySelectorAll error is: ', error);
                    }
                } else {
                    try {
                        document.querySelectorAll('[data-quick-view-handle="' + product.handle + '"]')?.forEach((moreBtn) => {
                            moreBtn.classList.add('hidden');
                        });
                    } catch (error) {
                        console.log('document.querySelectorAll error is: ', error);
                    }
                }
            } else {
                html = html + '<li>';
                html = html + `<button class="btn btn-link quick-variant-selector__button" data-variant-id="${product.variants[0].id}" aria-label="Add to bag" data-available="${product.variants[0].available}">Add to bag</button>`;
                html = html + '</li>';
                try {
                    document.querySelectorAll('[data-quick-view-handle="' + product.handle + '"]')?.forEach((moreBtn) => {
                        moreBtn.classList.add('hidden');
                    });
                } catch (error) {
                    console.log('document.querySelectorAll error is: ', error);
                }
            }

            html = html + '</ul>';

            html = html + '</component-tooltip>';

            this.innerHTML = html;

            this.initEvents();

            this.triggerRender();
        }
    }

    /**
     * Trigger render event
     * 
     * @returns {undefined}
     */
    triggerRender() {

        this.classList.add('ready');

        let event = new CustomEvent('ready', { 'detail': {} });

        this.dispatchEvent(event);

        return event;
    }

    /**
     * Init events
     * 
     * @returns {undefined}
     */
    initEvents() {

        this.querySelectorAll('button[data-variant-id]').forEach(btn => {

            btn.addEventListener('click', event => {

                let variant = this.getVariant(event.target.dataset.variantId);

                this.updateVariantSelector(variant);

                this.closeTooltip();

            });

            hoverintent(btn, () => {
                const stockWrapper = document.querySelector('[data-variant-stocklevel="' + btn.dataset.variantId + '"]');
                if (stockWrapper) {
                    // Add active class to both wrapper and component
                    stockWrapper.classList.add('active');
                    const stockComponent = stockWrapper.querySelector('stocklevel-component');
                    if (stockComponent) {
                        stockComponent.classList.add('active');
                    }
                }
            }, () => {
                const stockWrapper = document.querySelector('[data-variant-stocklevel="' + btn.dataset.variantId + '"]');
                if (stockWrapper) {
                    stockWrapper.classList.remove('active');
                    const stockComponent = stockWrapper.querySelector('stocklevel-component');
                    if (stockComponent) {
                        stockComponent.classList.remove('active');
                    }
                }
            });

        });


    }

    /**
     * Close tooltip
     * 
     * @param {integer} variantId Variant Id.
     * @returns {undefined}
     */
    closeTooltip() {

        let event = new CustomEvent('close', { 'detail': {} });

        this.querySelector('component-tooltip').dispatchEvent(event);

        return event;
    }

    /**
     * Get variant
     * 
     * @param {integer} variantId Variant Id.
     * @returns {undefined}
     */
    getVariant(variantId) {

        let variant = null;

        this.options.forEach(option => {

            if (option.variantId == variantId) {

                variant = option.variant;
            }
        });

        return variant;
    }

    /**
     * Update variant selector web component.
     * 
     * @param {object} variant Product variant data.
     * @returns {undefined}
     */
    updateVariantSelector(variant) {

        let variantSelector = document.querySelector('variant-selector[data-handle="' + this.dataset.handle + '"] select');

        if (variantSelector) {

            variantSelector.value = (variant) ? variant.id : '';

            variantSelector.dispatchEvent(new Event("change"));
        }
    }

    /**
     * Get variant selector web component.
     * 
     * @returns {object} Variant selector web component from DOM.
     */
    getVariantSelector() {
        return document.querySelector('variant-selector[data-handle="' + this.dataset.handle + '"] select');
    }
}

customElements.define('quick-variant-selector', quickVariantSelector);
